import ThemedSvgIcon from './ThemedSvgIcon';

const ShieldHalvedIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50002 0.5C9.67971 0.5 9.85939 0.539063 10.0235 0.613281L17.3789 3.73438C18.2383 4.09766 18.8789 4.94531 18.875 5.96875C18.8555 9.84375 17.2617 16.9336 10.5313 20.1562C9.87892 20.4688 9.12111 20.4688 8.46877 20.1562C1.7383 16.9336 0.144549 9.84375 0.125018 5.96875C0.121112 4.94531 0.761736 4.09766 1.62111 3.73438L8.98049 0.613281C9.14064 0.539063 9.32033 0.5 9.50002 0.5ZM9.50002 3.10938V17.8789C14.8906 15.2656 16.3399 9.48828 16.375 6.02344L9.50002 3.10938Z"
                    fill={fill}
                />
            </svg>
        )}
    </ThemedSvgIcon>
);

export default ShieldHalvedIcon;
